import { render, staticRenderFns } from "./deviceLabelList.vue?vue&type=template&id=5b1f17aa&scoped=true&"
import script from "./deviceLabelList.vue?vue&type=script&lang=js&"
export * from "./deviceLabelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1f17aa",
  null
  
)

export default component.exports